export default "__VITE_ASSET__CLcPj1Ir__"